import { debounce } from "../utils/performance";
import Slider from "./slider";

export default function (el) {
    const slider = Slider(el);
    const dots = el.querySelectorAll(".ct__dot");
    let rowHeights = [];

    const changeDotState = (index, actionType) => dots[index] && dots[index].classList[actionType]("ct__dot--active");

    const handleDotClick = (dot) => dot.dataset.index && slider.slideTo(dot.dataset.index);

    const loopSlideCells = (cb) => slider.slides.forEach(slide => {
        const cells = slide.querySelectorAll(".ct__slide-cell");

        if(cells.length === 0) return;

        cells.forEach((cell, index) => cb.call(null, cell, index));
    });

    const getRowHeights = (cell, index) => {
        const cellHeight = cell.offsetHeight;

        if (!rowHeights[index] || cellHeight > rowHeights[index])
            rowHeights[index] = cellHeight;
    }

    const setCellHeight = (cell, index) => {
        if (rowHeights[index] && cell.offsetHeight < rowHeights[index])
            cell.style.height = `${rowHeights[index]}px`;
    }

    const setCellsHeights = () => {
        rowHeights = [];
        loopSlideCells(getRowHeights);
        loopSlideCells(setCellHeight);
    }

    const handleWindowResize = debounce(setCellsHeights, 300, false);

    window.addEventListener("resize", handleWindowResize);
    setCellsHeights();

    if(dots.length === 0) return;

    slider.on("slideChange", () => {
        changeDotState(slider.previousIndex, "remove");
        changeDotState(slider.realIndex, "add");
    });

    dots.forEach(dot => dot.addEventListener("click", handleDotClick.bind(null, dot)));
    changeDotState(slider.realIndex, "add");
}